import {
  validateLength,
  validateNumber,
} from 'ember-changeset-validations/validators';
import { customMessageValidator } from 'uplisting-frontend/validators/custom-message';
import { INSTANT_BOOK_WELCOME_MESSAGE_MAX_LENGTH } from 'uplisting-frontend/models/airbnb-official-listing';

export const AirbnbOfficialListingValidation = {
  nonRefundableDiscount: validateNumber({
    allowBlank: true,
    gte: 1,
    lte: 99,
  }),

  instantBookWelcomeMessage: customMessageValidator(
    'property_basics_instant_book_welcome_message_length',
    validateLength({ max: INSTANT_BOOK_WELCOME_MESSAGE_MAX_LENGTH }),
  ),
};
